export const eventHandlers = {};



// WEBPACK FOOTER //
// ./src/widget/analytics/bi/index.js